<div style="height: fit-content !important;">
<div>{{ description + getPartNr() }} </div>
<div *ngIf="showAlternative" style="font-style: italic;">{{ altDescription }} </div>
</div>
